<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <div class="doc-preview" *ngIf="isLoading">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <div class="doc-preview doc-preview--error" *ngIf="!isLoading && hasError">
    <mat-icon>broken_image</mat-icon>
    <p>This document could not be loaded.</p>
  </div>

  <img
    *ngIf="!isLoading && !hasError"
    class="doc-preview__image"
    [src]="imageSrc"
    [alt]="data.title"
    (error)="onImageError()" />
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" class="btn ghost-btn" (click)="close()">Close</button>
</mat-dialog-actions>
